import Request from "./constants/Request.api"
import Response from "./constants/Response.api"
import Api from "./Api"

class Licensing extends Api {
  constructor(user) {
    super()
    this.user = user
  }

  createApplication = service_id => {
    const request = new Request({
      data: {
        client_id: this.user.id,
        url: "client/application/" + service_id,
        token: "Bearer " + this.user.token,
      },
    })

    const response = this.postRequest(request)
    return response
  }

  //
  saveApplicationBasel = appForm => {
    const request = new Request({
      data: {
        ...appForm,
        client_id: this.user.id,
        is_submitted: true,
        url: "clients/applications/application-basel-convention",
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  saveApplicationRotterdam = appForm => {
    const request = new Request({
      data: {
        ...appForm,
        client_id: this.user.id,
        is_submitted: true,
        url: "clients/applications/application-rotterdam-convention",
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  saveApplicantWasteIds = (applicationId, wasteData) => {
    const request = new Request({
      data: {
        wasteIdentifications: wasteData,
        application_id: applicationId,
        url: "waste-identifications-applicant",
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  saveTransitStates = (applicationId, states) => {
    const request = new Request({
      data: {
        application_id: applicationId,
        transit_states: states,
        url: "transit-states",
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  getAllWasteIdentifications = () => {
    const request = new Request({
      data: {
        url: "waste-identifications",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getNotificationConcerning = () => {
    const request = new Request({
      data: {
        url: "notification-concernings",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getBaselPurposes = () => {
    const request = new Request({
      data: {
        url: "basel-purposes",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getQuantityMeasures = () => {
    const request = new Request({
      data: {
        url: "quantity-measures",
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getClientWasteIds = application_id => {
    const request = new Request({
      data: {
        url: "waste-identifications-applicant/" + application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getTransitStates = application_id => {
    const request = new Request({
      data: {
        url: "transit-states/" + application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getServiceAttachments = service_id => {
    const request = new Request({
      data: {
        url: "service/attachments/" + service_id,
        client_id: this.user.id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getClientWasteIds = application_id => {
    const request = new Request({
      data: {
        url: "waste-identifications-applicant/" + application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getClientTransitStates = application_id => {
    const request = new Request({
      data: {
        url: "transit-states/" + application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
}

export default Licensing
